<div class="access-level-component">
  <mat-form-field>
    <mat-label>Access level</mat-label>
    <mat-select [formControl]="formControl">
      @for (option of options; track option) {
        <mat-option [value]="option.type" [disableControl]="disabled">
          {{option.name}}
        </mat-option>
      }
    </mat-select>
    @for (errorKey of errorKeys(formControl); track errorKey) {
      <mat-error>
        @if (formControl.touched && formControl.hasError(errorKey)) {
          {{errorMessage(formControl, errorKey)}}
        }
      </mat-error>
    }
  </mat-form-field>
</div>
